import { useTheme } from 'foundations-theming/utils';
import ContentViewport from '../ContentViewport';
import { jsx as _jsx } from "react/jsx-runtime";
const InterstitialContentViewport = ({
  children,
  viewportStyles
}) => {
  const theme = useTheme();
  const extraViewportStyles = Object.assign({}, viewportStyles, {
    backgroundColor: theme.color['fill-surface-default']
  });
  return /*#__PURE__*/_jsx(ContentViewport, {
    viewportStyles: extraViewportStyles,
    children: children
  });
};
export default InterstitialContentViewport;